// @flow

import { Text } from 'reshaped';

import { useTranslator } from '@gandi/translate';

export function StudioAccountHeader(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <>
      <Text variant="featured-3" weight="bold">
        {__('Just your phone number, and you are all set!')}
      </Text>
      <Text variant="body-3" color="neutral-faded">
        {__('Enter this last bit of information to complete your order.')}
      </Text>
    </>
  );
}
